import { reactive } from "vue";
import { api } from "./api";

const DRIVER_KEY = "haul-gauge-driver-token";
const ADMIN_KEY = "haul-gauge-admin-token";

export const session = reactive({
  driverToken: localStorage.getItem(DRIVER_KEY) || "",
  adminToken: sessionStorage.getItem(ADMIN_KEY) || "",
  driver: null as Record<string, unknown> | null,
  vehicle: null as Record<string, unknown> | null,
});

export async function demoLogin(nickname: string) {
  const result = await api.post<{ token: string; driver: Record<string, unknown> }>("/auth/demo", {
    nickname, clientId: "acceptance",
  });
  session.driverToken = result.token; session.driver = result.driver;
  localStorage.setItem(DRIVER_KEY, result.token);
  return result;
}

export async function loadProfile() {
  if (!session.driverToken) return null;
  const result = await api.get<{ driver: Record<string, unknown>; vehicle: Record<string, unknown> }>("/driver/me", session.driverToken);
  session.driver = result.driver; session.vehicle = result.vehicle;
  return result;
}

export function logoutDriver() {
  session.driverToken = ""; session.driver = null; session.vehicle = null;
  localStorage.removeItem(DRIVER_KEY);
}

export async function adminLogin(password: string) {
  const result = await api.post<{ token: string; user: Record<string, unknown> }>("/admin/auth", { password });
  session.adminToken = result.token; sessionStorage.setItem(ADMIN_KEY, result.token);
  return result;
}

export function logoutAdmin() {
  session.adminToken = ""; sessionStorage.removeItem(ADMIN_KEY);
}
